export default __webpack_public_path__ + "static/media/nirvana-album.2cd1a9e1.png";